import React, { useState, useEffect } from 'react';
import api from '../services/api';

const overlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
const modal = { background: '#fff', borderRadius: 12, padding: 28, width: 440, maxWidth: '90vw', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 8px 30px rgba(0,0,0,.15)' };
const inputStyle = { width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };
const labelStyle = { display: 'block', fontWeight: 600, fontSize: 13, marginBottom: 4, color: '#333' };
const btnPrimary = { background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', fontWeight: 600, cursor: 'pointer', fontSize: 14 };
const btnSecondary = { background: '#f1f5f9', color: '#666', border: 'none', borderRadius: 8, padding: '10px 24px', fontWeight: 600, cursor: 'pointer', fontSize: 14 };
const errStyle = { color: '#ef4444', fontSize: 13, marginTop: 4 };

export default function EditQRModal({ qr, onClose, onSaved }) {
  const [categories, setCategories] = useState([]);
  const [title, setTitle] = useState(qr.title || '');
  const [targetUrl, setTargetUrl] = useState(qr.target_url || '');
  const [categoryId, setCategoryId] = useState(qr.category_id || '');
  const [fgColor, setFgColor] = useState(qr.fg_color || '#000000');
  const [bgColor, setBgColor] = useState(qr.bg_color || '#ffffff');
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    api.get('/categories').then(r => setCategories(r.data)).catch(() => {});
  }, []);

  const validate = () => {
    const e = {};
    if (!title.trim()) e.title = 'Label is required';
    if (!targetUrl.trim()) e.targetUrl = 'Destination URL is required';
    else {
      try { new URL(targetUrl); } catch { e.targetUrl = 'Must be a valid URL'; }
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const save = async () => {
    if (!validate()) return;
    setSaving(true);
    try {
      const { data } = await api.put(`/qr/${qr.id}`, {
        title: title.trim(),
        target_url: targetUrl.trim(),
        category_id: categoryId || null,
        fg_color: fgColor,
        bg_color: bgColor,
      });
      onSaved(data);
    } catch (err) {
      setErrors({ general: err.response?.data?.error || 'Failed to save' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <h3 style={{ marginTop: 0, marginBottom: 20 }}>Edit QR Code</h3>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Label</label>
          <input style={inputStyle} value={title} onChange={e => setTitle(e.target.value)} />
          {errors.title && <div style={errStyle}>{errors.title}</div>}
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Destination URL</label>
          <input style={inputStyle} value={targetUrl} onChange={e => setTargetUrl(e.target.value)} placeholder="https://..." />
          {errors.targetUrl && <div style={errStyle}>{errors.targetUrl}</div>}
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Category</label>
          <select style={inputStyle} value={categoryId} onChange={e => setCategoryId(e.target.value)}>
            <option value="">None</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>

        <div style={{ display: 'flex', gap: 14, marginBottom: 20 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Foreground Color</label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input type="color" value={fgColor} onChange={e => setFgColor(e.target.value)} style={{ width: 40, height: 36, border: 'none', cursor: 'pointer' }} />
              <input style={{ ...inputStyle, flex: 1 }} value={fgColor} onChange={e => setFgColor(e.target.value)} />
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Background Color</label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input type="color" value={bgColor} onChange={e => setBgColor(e.target.value)} style={{ width: 40, height: 36, border: 'none', cursor: 'pointer' }} />
              <input style={{ ...inputStyle, flex: 1 }} value={bgColor} onChange={e => setBgColor(e.target.value)} />
            </div>
          </div>
        </div>

        <p style={{ fontSize: 12, color: '#999', marginBottom: 16 }}>
          Short code <code>/q/{qr.code}</code> will not change — only metadata and destination are updated.
        </p>

        {errors.general && <div style={{ ...errStyle, marginBottom: 12 }}>{errors.general}</div>}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button style={btnSecondary} onClick={onClose} disabled={saving}>Cancel</button>
          <button style={btnPrimary} onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</button>
        </div>
      </div>
    </div>
  );
}
